import React, { useEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const WorkerPieChart = ({ data, currentLanguage }) => {
  useEffect(() => {
    let root = am5.Root.new("workerPieChartDiv");

    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
      })
    );

    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
      })
    );

    const formattedData = data.map((item) => ({
      category: item?.subServiceName[currentLanguage]?.toUpperCase(),
      value: item.totalAppointments,
    }));

    series.data.setAll(formattedData);

    series.labels.template.set("visible", false);
    series.ticks.template.set("visible", false);

    series.slices.template.setAll({
      fillOpacity: 0.9,
      strokeOpacity: 0,
    });

    series.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [data]);

  return (
    <div
      id="workerPieChartDiv"
      style={{ width: "100%", height: "300px" }}
    ></div>
  );
};

export default WorkerPieChart;
